import { h } from 'preact';

// "Voor: Voetbal · Scouting" on a news item meant for certain groups; nothing for everyone
export default function NewsAudienceLabel({ audience }) {
  if (!audience?.length) return null;
  const names = audience.map(a => a.name).join(' · ');
  return (
    <span title={`Alleen zichtbaar voor: ${names}`} style="font-size:11px;background:#e0e7ff;color:#3730a3;padding:2px 8px;border-radius:10px;font-weight:500;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
      Voor: {names}
    </span>
  );
}
